import React from "react";
import styled from 'styled-components';

import { Paragraph } from "../theme/typography";
import StandardBlock, { StandardContent } from "./StandardBlock";

import IntroBackgroundVertical from '../images/homepage/ed-bgr-vertical.webp';
import IntroBackgroundHorizontal from '../images/homepage/ed-bgr-horizontal.webp';

const Greeting = styled.h2`
    ${(props) => props.theme.typography.headingL};

    @media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
        ${(props) => props.theme.typography.headingXL};
    }

    @media only screen and (min-width: ${(props) => props.theme.breakpoints.sixth}) {
        ${(props) => props.theme.typography.heading3XL};
    }
`;

const FirstSentence = styled.h3`
    ${(props) => props.theme.typography.headingS};

    @media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
        ${(props) => props.theme.typography.headingM};
    }

    @media only screen and (min-width: ${(props) => props.theme.breakpoints.sixth}) {
        ${(props) => props.theme.typography.headingL};
    }
`;

export class IntroBlock extends React.Component {
    render() {
        return (
            <StandardBlock
                id="about"
                colorScheme="dark"
                portraitBg={IntroBackgroundVertical}
                landscapeBg={IntroBackgroundHorizontal}
				portraitGradient={true}
				landscapeGradient={true}
                fullHeightOnMobile={true}
                alignment="left"
            >
                <StandardContent>
                    <Greeting>Hey, I'm Ed!</Greeting>
                    <FirstSentence>I started Tressym because I love designing racing drones.</FirstSentence>
                    <Paragraph>
                        I put a lot of thought into every detail of my designs. Every arc, every hundredth of a gram is carefully considered.
                    </Paragraph>
                    <Paragraph>
                        But what makes Tressym frames truly great is all the support, feedback and ideas from the amazing pilots who fly them.
                    </Paragraph>
                </StandardContent>
            </StandardBlock>
        );
    }
}